import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Grid, Row } from 'react-bootstrap';


const propTypes = exact({
  render: PropTypes.func.isRequired,
});


const DefaultLayout = (props) => {
  const { render } = props;

  return (
    <Grid fluid>
      {/*
      <Row>
        <Header/>
      </Row>
      */}
      <Row>
        {/*
         * This content is not wrapped in a Col to prevent additional padding added by the column
         * gutter. This saves on badly needed horizontal space.
         */}
        {render()}
      </Row>
    </Grid>
  );
};


DefaultLayout.propTypes = propTypes;


export default DefaultLayout;
